import { Icons } from '@/components/icons';
import { Typography } from '@/components/primitives/Typography';
import type { IntermediateStopDTO } from '@/types/dto/agent';
import { formatTime } from '@/utils/dateTime';
import type { FC } from 'react';

interface LegIntermediateStopProps {
  stop: IntermediateStopDTO;
}

const LegIntermediateStop: FC<LegIntermediateStopProps> = ({ stop }) => {
  const arrivalTime = formatTime(stop.arrivalTime);
  const departureTime = formatTime(stop.departureTime);

  return (
    <div className="relative grid grid-cols-[1fr_64px_64px]">
      <Icons.destination
        width={10}
        height={10}
        className="absolute -left-[31px] top-0.5 bg-white text-neutral-light"
      />
      <Typography variant="body2" className="text-wrap">
        {stop.name}
      </Typography>
      <Typography variant="body2" className="justify-self-center">
        {arrivalTime}
      </Typography>
      <Typography variant="body2" className="justify-self-center">
        {departureTime}
      </Typography>
    </div>
  );
};

export default LegIntermediateStop;
